import React from 'react';
import { ShoppingBag, MapPin, CreditCard, Wallet, ArrowLeftRight, Receipt, Ticket, LogOut, User, Lock, LogOutIcon } from 'lucide-react';
import { ROUTES } from './Routes';
import { set_user } from '../../../actions/user';

// تعریف آیتم‌های منو با آیکون‌های مناسب
export const profileMenuDescktop = [
  {
    id: 1,
    title: 'سفارش‌ها',
    icon: <ShoppingBag size={24} />,
    iconClass: 'defaultIcon-optionHeader',
    onClick: () => console.log('سفارش‌ها clicked'),
    link: ROUTES.ORDER_MAIN,
  },
  {
    id: 2,
    title: 'آدرس‌ها',
    icon: <MapPin size={24} />,
    iconClass: 'defaultIcon-optionHeader',
    onClick: () => console.log('آدرس‌ها clicked'),
    link: ROUTES.ADDRESS_LIST,
  },
  {
    id: 8,
    title: 'تیکت',
    icon: <Ticket size={24} />,
    iconClass: 'defaultIcon-optionHeader',
    onClick: () => console.log('تیکت clicked'),
    link: ROUTES.TICKET_LIST,
  },
  {
    id: 9,
    title: 'تغییر رمز عبور',
    icon: <Lock size={24} />,
    iconClass: 'defaultIcon-optionHeader',
    onClick: () => console.log('لیست تراکنش‌ها clicked'),
    link: ROUTES.NEW_PASSWORD,
  },
  {
    id: 9,
    title: 'خروج',
    icon: <LogOutIcon size={24} />,
    iconClass: 'defaultIcon-optionHeader',
    onClick: () => console.log('لیست تراکنش‌ها clicked'),
    link: ROUTES.NEW_PASSWORD,
  },
];
